/**
 * The retirement marker (v41/v42/v44 `retMark`): a dotted vertical rule at the retirement year,
 * labelled above the plot ("Retirement, 2053"), not inside it where it lands on whatever value is
 * at that height. The year comes from the household's retirement (plan-view `retirementYear`), never
 * a constant; charts that draw it leave room above the top gridline.
 */
export function RetirementMark({
  x,
  top,
  bottom,
  year,
  label,
}: {
  x: number;
  top: number;
  bottom: number;
  year: number;
  label?: string;
}) {
  return (
    <g className="retmark" data-testid="retirement-mark">
      <line
        x1={x.toFixed(1)}
        x2={x.toFixed(1)}
        y1={top}
        y2={bottom}
        stroke="var(--ink3)"
        strokeWidth="1"
        strokeDasharray="2 4"
        opacity=".75"
      />
      <text
        x={x.toFixed(1)}
        y={top - 11}
        textAnchor="middle"
        fontSize="11.5"
        fontWeight="700"
        fill="var(--ink3)"
      >
        {label ?? `Retirement, ${year}`}
      </text>
    </g>
  );
}
